// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"-F8W1j"};